import React, { useState } from "react";
import { ArrowLeft, ArrowRight, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AdminAuthFrame } from "@/components/AdminAuthFrame";
import { supabase } from "@/lib/supabase";

const AdminForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/admin/reset-password`,
    });
    setSubmitting(false);
    if (error) return toast.error(error.message);
    setSent(true);
    toast.success("Password reset email sent.");
  };

  return (
    <AdminAuthFrame eyebrow="Account Recovery" title="Forgot Password?" description="Enter your admin email and we’ll send a secure password reset link.">
      {sent ? (
        <div className="text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-50 text-blue-600"><Mail className="h-7 w-7" /></span>
          <h2 className="mt-4 text-lg font-bold text-slate-900">Check your inbox</h2>
          <p className="mt-2 text-sm text-slate-500">If an admin account exists for <strong className="text-slate-700">{email}</strong>, a reset link has been sent.</p>
          <Link to="/admin/login" className="btn-blue mt-6 w-full">Return to Login <ArrowRight className="h-4 w-4" /></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <label className="block text-xs font-semibold text-slate-600">
            Email Address
            <span className="relative mt-1.5 block">
              <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <input required type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="admin@example.co.za" autoComplete="email" className="w-full rounded-lg border border-slate-200 bg-slate-50 py-2.5 pl-9 pr-3 text-sm focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-100" data-testid="forgot-password-email-input" />
            </span>
          </label>
          <button type="submit" disabled={submitting} className="btn-blue w-full" data-testid="forgot-password-submit-button">{submitting ? "Sending..." : "Send Reset Link"} <ArrowRight className="h-4 w-4" /></button>
          <Link to="/admin/login" className="flex items-center justify-center gap-1.5 text-sm font-semibold text-blue-600 hover:underline"><ArrowLeft className="h-4 w-4" /> Back to Login</Link>
        </form>
      )}
    </AdminAuthFrame>
  );
};

export default AdminForgotPassword;
